module.exports = __webpack_public_path__ + "media/images/front/icon_trophy_silver-eaa84aa9ce0df02a4fef7b16a5c558cd.png";